import { createApp } from "vue";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import ko from 'element-plus/es/locale/lang/ko';

const routes = [
  {
    path: "/",
    name: "Activate",
    component: App,
    meta: { title: '개통정보제출' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.afterEach((to) => {
  const defaultTitle = '유심스토어'; // 기본 타이틀
  document.title = to.meta.title || defaultTitle;
});

const app = createApp(App);
app.use(router);
app.use(ElementPlus, {
  locale: ko, // 한국어 설정
});
app.mount("#app");
